module.exports = __webpack_public_path__ + "img/ChromeWebStore_Badge_v2_206x58.1b024992.png";